import React from "react";
import Box from "@material-ui/core/Box";
import Calendar from "storybookComponents/Calendar";
import { getPreviousMonday, processEvents } from "../CalendarUtils";

export default ({
  date,
  events,
  onEditClickedCallback,
  onDuplicateClickedCallback,
  onCancelClickedCallback,
  onArchiveClickedCallback,
  onPreviewClickedCallback,
  onUnarchiveClickedCallback,
  onPublishClickedCallback,
}) => {
  return (
    <Box style={{ marginTop: 20, height: "100%" }}>
      <Calendar
        startDate={getPreviousMonday(new Date(date))}
        events={processEvents(events)}
        onEditClickedCallback={onEditClickedCallback}
        onDuplicateClickedCallback={onDuplicateClickedCallback}
        onCancelClickedCallback={onCancelClickedCallback}
        onArchiveClickedCallback={onArchiveClickedCallback}
        onPreviewClickedCallback={onPreviewClickedCallback}
        onUnarchiveClickedCallback={onUnarchiveClickedCallback}
        onPublishClickedCallback={onPublishClickedCallback}
      />
    </Box>
  );
};
